import Vue from 'vue';
import Vuex from 'vuex';
import { debounce } from 'lodash';

import { axios, filterValueToQuery } from '@/api/index';
import { paginatorInfo } from '@/types/index';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    me: {},
    dashboard: [],
    unauthorizeModal: false,
    materials: {},
    latestMaterialsFilter: {},
    ranMaterials: false,
  },
  mutations: {
    setMe(state, payload) {
      state.me = payload;
    },
    setDashboard(state, payload) {
      state.dashboard = payload;
    },
    setUnauthorizeModal(state, payload: boolean) {
      state.unauthorizeModal = payload;
    },
    async SET_MATERIALS(state, payload) {
      const { materials, filter } = payload;
      state.materials = materials;
      state.ranMaterials = true;
      state.latestMaterialsFilter = filter;
    },
  },
  actions: {
    async GET_MATERIALS({ commit }, filterString: any) {
      const response = await axios.get(`/api/materials?${filterString}`);
      if (response?.status === 200) {
        await commit('SET_MATERIALS', {
          materials: response.data,
          filter: filterString,
        });
      }
    },
  },
  modules: {
  },
  getters: {
    me(state) {
      return state.me;
    },
    dashboard(state) {
      return state.dashboard;
    },
    unauthorizeModal(state) {
      return state.unauthorizeModal;
    },
    GET_MATERIALS: (state) => async () => state.materials,
    GET_RAN_MATERIALS: (state) => async () => state.ranMaterials,
    GET_LAST_KNOWN_MATERIALS_FILTER: (state) => async () => state.latestMaterialsFilter,
  },
});
